module.exports = __webpack_public_path__ + "assets/img/16.ea1ec901.png";